import { render } from "./Registrations.vue?vue&type=template&id=3422ae70&ts=true"
import script from "./Registrations.vue?vue&type=script&lang=ts"
export * from "./Registrations.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__